import Vue from 'vue';
import VueAnimateOnScroll from 'vue-animate-onscroll';
Vue.use(VueAnimateOnScroll);
